export default __webpack_public_path__ + "static/media/Group696.f2a4f9e2.svg";